module.exports = __webpack_public_path__ + "static/img/s1.a516d25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/s1.png
// module id = p/7K
// module chunks = 0